import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import Info from "../../ui/widgets/info";
import CustomLink from "../../ui/widgets/link";
import ChoosePerson from "../shared/components/choose-person";
import { AdminContext } from "./adminContext";
import Person from "./person";
import SectionFullWidthContainer from "../../ui/layout/page/forms-container/section-full-width-container";
import CustomTypography from "../../ui/widgets/typography";
import FormContainer from "../../ui/layout/page/forms-container/form-base-container";
import { RegulatoryInformationModel } from "./types";

export interface BeneficialOwnerProps {
  isOwnerSameAsAdmin: RegulatoryInformationModel["isOwnerSameAsAdmin"];
  beneficialOwner: RegulatoryInformationModel["beneficialOwner"];
}

export const BeneficialOwner = ({
  isOwnerSameAsAdmin,
  beneficialOwner,
}: BeneficialOwnerProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const { admin } = useContext(AdminContext);

  return (
    <>
      <SectionFullWidthContainer>
        <CustomTypography variant="h3">
          {getMessage("BeneficialOwner.title")}
        </CustomTypography>
      </SectionFullWidthContainer>
      <FormContainer>
        <>
          <RadioButtonContainer>
            <div className="scd-section-pusher-lg">
              <ChoosePerson
                title={getMessage("BeneficialOwner.description")}
                id="isOwnerSameAsAdmin"
                name="isOwnerSameAsAdmin"
                values={[
                  {
                    id: "owner-same-as-admin-yes",
                    value: "yes",
                    messageKey: "BeneficialOwner.SAME_AS_CONTACT",
                    person: admin,
                  },
                  {
                    id: "owner-same-as-admin-no",
                    value: "no",
                    messageKey: "BeneficialOwner.OTHER",
                  },
                ]}
              />
            </div>
          </RadioButtonContainer>
          {isOwnerSameAsAdmin === "yes" && (
            <Person
              owner={beneficialOwner.admin}
              dataPath="beneficialOwner.admin."
            />
          )}
          {isOwnerSameAsAdmin === "no" && (
            <Person
              owner={beneficialOwner.other}
              dataPath="beneficialOwner.other."
            />
          )}
          <Info>
            {getMessage("BeneficialOwner.addAdditional-info")}
            <CustomLink
              noicon
              target="_blank"
              rel="noopener noreferrer"
              id="BeneficialOwner.addAdditional.link"
              href={getMessage("BeneficialOwner.addAdditional-url")}
            >
              {getMessage("BeneficialOwner.addAdditional")}
            </CustomLink>
          </Info>
        </>
      </FormContainer>
    </>
  );
};
